<loader [showLoader]="showLoader"></loader>
<div
  class="m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop 	m-container m-container--responsive m-container--xxl m-page__container m-body">
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-content">
      <div class="row">
        <div class="col-sm-12">
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <h3 class="m-portlet__head-text">
                    Product Series Listing
                  </h3>
                </div>
              </div>
              <div class="m-portlet__head-tools">
                <ul class="m-portlet__nav">
                  <li class="m-portlet__nav-item" style="margin-right:193px;" [hidden]="!isProductPriceEditable">
                    <button id="import" (click)="DownloadListHistory()"
                      class="btn btn-primary m-btn m-btn--air m-btn--custom">Price List History
                    </button>
                  </li>
                  <li class="m-portlet__nav-item absdwnl pt-0 pr-0" [hidden]="!isProductPriceEditable" style="margin-right: -22px;">
                      <mat-form-field class="" style="width: 185px;">
                        <mat-label>Price List Download</mat-label>
                        <mat-select>
                          <mat-option *ngFor="let sr of SeriesName" [value]="sr.Id" (click)="ExportData(sr.Id)">
                            {{sr.SeriesName}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                  </li>
                  <li class="m-portlet__nav-item" [hidden]="!isProductPriceEditable">
                    <input class="form-control m-input" name="ProductPriceData" (change)="getfiledetails($event)"
                      type="file" hidden (click)="file.value = null" #file>

                    <button id="import" (click)="file.click()"
                      class="btn btn-primary m-btn m-btn--air m-btn--custom">Price List Upload
                    </button>
                  </li>
                  <li class="m-portlet__nav-item">
                    <a class="btn btn-primary m-btn m-btn--air m-btn--custom" [hidden]="!isProductSeriesEditable"
                      routerLink="/AddProductSeries">Add Product Series
                    </a>
                  </li>                 
                </ul>
              </div>
            </div>
            <div class="m-portlet__body">
              <div class="table-responsive">
                <div id="example_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6"></div>
                    <div class="col-sm-12 col-md-6 right">
                      <mat-form-field style="width: 50%;" class="pull-right">
                        <mat-label>Search</mat-label>
                        <input matInput (keyup)="SearchParam($event)" (keypress)="AvoidSpace($event)" maxlength="50"
                          placeholder="Search" #input>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                      class="table table-striped- table-bordered table-hover dataTable no-footer" role="grid">
                      <ng-container matColumnDef="ProductLineName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Line </th>
                        <td mat-cell *matCellDef="let row"> {{row.ProductLineName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="ProductFamilyName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Family </th>
                        <td mat-cell *matCellDef="let row"> {{row.ProductFamilyName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="SeriesName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Series </th>
                        <td mat-cell *matCellDef="let row"> {{row.SeriesName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="Action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let row">
                          <a mat-icon-button color="accent" [routerLink]="['/EditViewProductSeries',row?.Id]"
                            routerLinkActive="active" title="View">
                            <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                          </a>&nbsp;&nbsp;&nbsp;&nbsp;
                          <mat-slide-toggle [hidden]="!isProductSeriesEditable" class="example-margin"
                            [checked]="row.Status" [disabled]="disabled"
                            (change)="UpdateProductSeriesStatusById(row.Id,row.Status)">
                          </mat-slide-toggle>&nbsp; {{row.Status==true ? 'Active': 'Inactive'}}
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div
                      *ngIf="dataSource != undefined && (dataSource.filteredData == null || dataSource.filteredData?.length === 0)"
                      class="text-center">No records found</div>

                    
                    <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                      [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageEvent($event)">
                    </mat-paginator>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
